<template>
    <div>
        <documents
            :base_url="baseUrl"
            v-if="baseUrl"
        ></documents>
    </div>
</template>

<script>
import Documents from '@/components/Documents'
import { mapActions, mapState } from 'pinia'
import { useMessagingStore } from '@/stores/messagingStore'
import {services} from '@/assets/js/config.js'

export default {
    components: {
        Documents,
    },
    computed:{
        ...mapState(useMessagingStore, ['messenger']),
        baseUrl(){
            if(!this.messenger){
                return null
            }
            if(this.messenger.type === 'lead'){
                return services.lead + 'lead/' + this.messenger.id +'/attachments'
            }
            if(this.messenger.type === 'customer'){
                return services.customer + 'customer/' + this.messenger.id +'/attachments'
            }
        },
    },
}
</script>
